export const COMPANY = {
  name: "S&P Reinigungsservice",
  slogan: "Top Service · Starke Leistung · Faire Preise",
  city: "Esterwegen",
  street: "Kurze Straße 14",
  zip: "26897 Esterwegen",
  phone: "0162 / 94 29 140",
  phoneRaw: "+4916294229140",
  email: "info@sp-reinigungsservice.de",
  hours: [
    { d: "Montag – Freitag", h: "09:00 – 18:00 Uhr" },
    { d: "Samstag", h: "09:00 – 14:00 Uhr" },
    { d: "Sonntag", h: "geschlossen" },
  ],
};

export const SERVICES = [
  { key: "fenster", icon: "AppWindow", name: "Fensterreinigung", desc: "Fensterreinigung mit Rahmen und Falz – inklusive Schaufenster, Wintergärten und Terrassendächer." },
  { key: "jalousien", icon: "Blinds", name: "Jalousienreinigung", desc: "Reinigung von Jalousien, Raffstore und Fliegengittern – gründlich und schonend." },
  { key: "solar", icon: "SunMedium", name: "Solar & Photovoltaik", desc: "Fachgerechte Reinigung von Solar- und Photovoltaikanlagen für maximale Energieausbeute." },
  { key: "graffiti", icon: "SprayCan", name: "Graffiti-Entfernung", desc: "Rückstandslose Entfernung von Graffiti ohne Schäden am Untergrund." },
  { key: "osmose", icon: "Droplets", name: "Osmosereinigung", desc: "Osmosereinigung mit Reinstwasser für kalkfreie, glänzende Oberflächen – auch in der Höhe." },
  { key: "stein", icon: "Layers", name: "Steinreinigung", desc: "Fachgerechte Steinreinigung von Stein-, Naturstein- und Betonflächen." },
  { key: "dachrinne", icon: "CloudRain", name: "Dachrinnenreinigung", desc: "Reinigung von Dachrinnen, Dächern und Dachüberständen – vorbeugend gegen Wasserschäden." },
  { key: "unterhalt", icon: "Repeat", name: "Unterhaltsreinigung", desc: "Regelmäßige Unterhaltsreinigung für dauerhaft saubere Räume – planbar und zuverlässig." },
  { key: "grund", icon: "Sparkles", name: "Grundreinigung", desc: "Intensive Grundreinigung, die selbst hartnäckigen Schmutz vollständig entfernt." },
  { key: "buero", icon: "Building2", name: "Büroreinigung", desc: "Büroreinigung für repräsentative, dauerhaft saubere Arbeits- und Gewerbeflächen." },
  { key: "wohnung", icon: "House", name: "Haus & Wohnungsreinigung", desc: "Haus- und Wohnungsreinigung – vom Alltag bis zum großen Frühjahrsputz." },
  { key: "umzug", icon: "Truck", name: "Umzugsreinigung", desc: "Umzugsreinigung besenrein oder übergabefertig – damit der Start sauber gelingt." },
  { key: "bau", icon: "HardHat", name: "Bauendreinigung", desc: "Bauendreinigung nach Bau- und Renovierungsarbeiten – bezugsfertig ohne Bauschmutz." },
  { key: "treppe", icon: "Footprints", name: "Treppenhausreinigung", desc: "Reinigung von Treppenhäusern und Gemeinschaftsflächen für Ihre Immobilie." },
];
